import ResultTable from "../../Table/ResultTable";
import {MessageCodes} from "../MessageCodes";
import EmptyLine from "../../EmptyLine";
import ResultHeader from "../../Table/ResultHeader";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";

export function C20({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TDSRC001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the downstream reach lengths at the following {row.data.length} cross sections:
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell colSpan={6}>Downstream Reach Length (ft)</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell colSpan={3}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                                <ResultHeaderCell colSpan={3}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right'}}>LOB</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Channel</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>ROB</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>LOB</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Channel</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>ROB</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row.data.map(r => {
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{textAlign: 'left', width: 125}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{r.base?.lob}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{r.base?.channel}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{r.base?.rob}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{ResultCellHighlight(r.base?.lob, r.compare?.lob)}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{ResultCellHighlight(r.base?.channel, r.compare?.channel)}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{ResultCellHighlight(r.base?.rob, r.compare?.rob)}</ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.DSRC002.error_id: {
            return (
                <>
                    <ResultText>
                        There are added/removed cross section(s) DS of the following cross sections. Considering the River Station of the added/removed cross section(s), the identified DS RL differences are noted as consistent or inconsistent.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell>River Station</ResultHeaderCell>
                                <ResultHeaderCell>is DS RL differences consistent</ResultHeaderCell>
                                <ResultHeaderCell>Added/Removed Cross Sections</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {
                                    const added = r?.added_sections?.map(x => `${x} (A)`).join(', ')
                                    const removed = r?.removed_sections?.map(x => `${x} (R)`).join(', ')
                                    let text = added
                                    if(added && removed) {
                                        text = `${added}, ${removed}`
                                    }
                                    else if(removed) {
                                        text = `${removed}`
                                    }
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell>{r.cross_section}</ResultBodyCell>
                                            <ResultBodyCell>{r.consistent}</ResultBodyCell>
                                            <ResultBodyCell>
                                                {text}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}